/**
 * 考试管理 相关菜单配置
 *
 */
 import { lazyLoad } from "@/utils/lazyLoad";
 const workOrderManageRoute = [
   {
     component: lazyLoad,
     path: "/workOrder",
     meta: {
       title: "工单管理",
       icon: "icon-exam-manage",
     },
     children: [
       {
         path: "/workOrder/List",
         name: "workOrderList",
         component: () =>
           import(
            "@/pages/workOrderManage/workerList"
           ),
         meta: {
           title: "专员工单列表",
         },
       },
     ],
   },
 ];
 export default workOrderManageRoute;
 